import Api from '../../api'
import { delay } from 'redux-saga'
import {
  all,
  call,
  fork,
  put,
  select,
  take,
  takeEvery,
  takeLatest,
} from 'redux-saga/effects'
import {
  JWT_STORAGE_KEY,
  SETTINGS_STORAGE_KEY,
  RESET_PASSWORD_KEY,
  CLUSTER_KEY,
  SSO_TOKEN_KEY,
  LOGIN_TRACKED,
  LOGIN_FROM_ENTRATA,
  LANGUAGE_PREFERENCE,
  FORCE_LOGOUT,
  ENABLE_BULK_PAYMENT,
  LANGUAGE_SET_FROM_NORMAL_LOGIN,
  OTP_LOGIN,
  I18N_MOCK,
  RP_SESSION_COOKIE_DELETED,
  RP_SELECTED_LEASE_ID,
  RP_LEASE_ID,
  RP_PROPERTY_ID,
  PP_LOGIN_SUCCESS,
  IS_PUSH_NOTIFICATION_CALLED,
  ENTRATA_DOMAIN,
  USER_AUTH,
  IS_COMPANY_USER_FULL_ACCESS,
  SETUP_DATA_KEY,
  CLIENT_ID_KEY
} from 'portal-modules/common/constants/keys'
import {
  PAYMENT_ACCOUNT_ID,
  IS_RELINK_ACCOUNT,
  PLAID_CONFIRM_MICRODEPOSIT,
  PLAID_REDIRECTED,
  AUTO_PAYMENT_TYPE,
  PAYMENT_AMOUNT,
  RESTORE_FORM,
  IS_DONATION_SELECTED,
  AMOUNT_ERROR,
} from 'portal-modules/payments/constants/keys'
import decode from 'jwt-decode'
import generateRandomBytes from 'portal-modules/common/utils/generate-random-byte-string'
import { PRIVATE_ROOT } from '../../../common/constants/urls'
import { AUTH } from '../../constants/urls'
import getProjectName from 'portal-modules/common/utils/get-project-name'

import {
  setLoading,
  setLoadingSuccess,
  unsetLoading,
} from 'portal-modules/common/redux/modules/loading'
import { updateUserSettings, clearUserSettings } from './userSettings'
import createRequestSaga from 'portal-modules/common/redux/create-request-saga'
import { requestProductPermissions } from 'portal-modules/common/redux/modules/productPermissions'
import checkAuthenticated from 'portal-modules/common/utils/check-authenticated'
import createFormAction from 'portal-modules/common/redux/create-form-action'
import { isObject } from '@entrata/utils'
import { addError } from 'portal-modules/common/redux/modules/errors'
import ERROR_MSGS from '../../constants/error-message'
import {
  addSetupData,
  clearSetupData,
} from 'portal-modules/common/utils/sync-user-data'
import { receivePropertyAssociations } from 'portal-modules/properties/redux/modules/properties'
import { receiveContractPropertyAssociations } from 'portal-modules/contracts/redux/modules/contracts'
import { receiveAccountSettings } from 'portal-modules/settings/redux/modules/accountSettings'
import { resetLedger } from 'portal-modules/group-ledger/redux/modules/ledger'
import { resetBalanceDetails } from 'portal-modules/common/redux/modules/balanceDetails'
import { setDefaultLocale } from 'portal-modules/common/utils/language-details'
import { requestChecklists } from 'portal-modules/checklists/redux/modules/checklists'
import { SAVE_NOTIFICATION_SETTINGS_NEW } from 'portal-modules/settings/redux/modules/accountSettings'
import { event } from 'portal-modules/common/utils/google-analytics'
import { requestPropertyProductPermissions } from 'portal-modules/common/redux/modules/productPermissions'
import { resetBalanceDue } from 'portal-modules/common/redux/modules/balanceDue'
import {
  getSessionCookies,
  setSessionCookies,
  removeSessionCookies,
} from 'portal-utils/session-cookies'
import {
  getDecryptedAES256CBCToken,
  getEncryptedAES256CBCToken,
} from 'portal-modules/common/utils/crypto-encryption'
import parseQueryString from 'portal-modules/common/utils/parse-query-string'
import { logNrError } from 'portal-modules/common/utils/log-nr-error'
// action types
export const ADD_LOGIN_ERROR = 'rp/user/ADD_LOGIN_ERROR'
export const EMAIL_OTP_REQUEST = 'rp/user/EMAIL_OTP_REQUEST'
export const EMAIL_OTP_SUBMIT_REQUEST = 'rp/user/EMAIL_OTP_SUBMIT_REQUEST'
export const LOGIN_SUCCESSFUL = 'rp/user/LOGIN_SUCCESSFUL'
export const RENEW_SESSION_SUCCESSFULL = 'rp/user/RENEW_SESSION_SUCCESSFULL'
export const REQUEST_RENEW_SESSION = 'rp/user/REQUEST_RENEW_SESSION'
export const LOGOUT = 'rp/user/LOGOUT'
export const LOGOUT_COMPLETE = 'rp/user/LOGOUT_COMPLETE'
export const UPDATE_USER = 'rp/user/UPDATE_USER'
export const UPDATE_USER_PROPERTY = 'rp/user/UPDATE_USER_PROPERTY'
export const UPDATE_BRANDING = 'rp/user/UPDATE_BRANDING'
export const LOGIN_REQUEST = 'rp/user/LOGIN_REQUEST'
export const LIFT_LOCKOUT = 'rp/user/LIFT_LOCKOUT'
export const LOCK_USER_OUT = 'rp/user/LOCK_USER_OUT'
export const CHANGE_USER_ACCOUNT = 'rp/user/CHANGE_USER_ACCOUNT'
const REQUEST_LEASE_DATA = 'rp/user/REQUEST_LEASE_DATA'
export const REQUEST_PASSWORD_RESET = 'rp/user/REQUEST_PASSWORD_RESET'
const VERIFY_RESET_CODE = 'rp/user/VERIFY_RESET_CODE'
const UPDATE_PASSWORD = 'rp/user/UPDATE_PASSWORD'
export const PASSWORD_RESET = 'rp/user/PASSWORD_RESET'
const AUTHORIZE_PARTIAL = 'rp/user/AUTHORIZE_PARTIAL'
const CREATE_PASSWORD = 'rp/user/CREATE_PASSWORD'
const VERIFY_TOKEN = 'rp/user/VERIFY_TOKEN'
const TRACK_LOGIN = 'rp/user/TRACK_LOGIN'
const SET_USER_TOKEN = 'rp/user/SET_USER_TOKEN'

import { getLandingPage } from 'portal-modules/common/utils/landing-page'
import { localStorage as local } from '@entrata/utils'
import { updateLocaleCookie } from 'portal-modules/common/utils/language-update'
import { PUBLIC_ROOT } from 'portal-modules/common/constants/urls'
import getProjectConditions from 'portal-modules/common/utils/get-project-conditions'
import { getEmbeddedViewFlag } from 'portal-modules/common/utils/get-embedded-flag'
const { isTP, isRP, isRH, isNotRP } = getProjectConditions()
const is_embedded = getEmbeddedViewFlag()
const is_login_from_entrata = !local.get(LOGIN_FROM_ENTRATA) ? false : true
const is_pp_login_success = local.get(PP_LOGIN_SUCCESS) ?? false

// reducer
export default function user(state = {}, { payload, type }) {
  switch (type) {
    case LOGIN_SUCCESSFUL:
      return { ...state, ...payload.user }
    case RENEW_SESSION_SUCCESSFULL:
      return { ...state, token: payload }
    case LOGOUT_COMPLETE:
      return {}
    case UPDATE_USER:
      return { ...state, ...payload }
    case UPDATE_USER_PROPERTY:
      return { ...state, propertyId: payload.propertyId }
    case UPDATE_BRANDING:
      return { ...state, ...payload }
    case LOCK_USER_OUT:
      return { ...state, lockoutUntil: payload }
    case LIFT_LOCKOUT: {
      const { lockoutUntil, ...rest } = state
      return { ...rest }
    }
    case PASSWORD_RESET:
      return Object.entries(state).reduce((obj, [key, value]) => {
        if (key === 'reset') return obj
        return { ...obj, [key]: value }
      }, {})
    default:
      return state
  }
}

// action creators
export const login = (payload = {}) => ({ type: LOGIN_REQUEST, payload })
export const setTokenDetailsInCookie = (payload, callback) => ({
  type: SET_USER_TOKEN,
  payload,
  callback,
})

export const sendEmailOTP = (payload = {}) => ({
  type: EMAIL_OTP_REQUEST,
  payload,
})

export const requestSubmitOtp = (payload = {}) => ({
  type: EMAIL_OTP_SUBMIT_REQUEST,
  payload,
})

export const requestRenewToken = callback => ({
  type: REQUEST_RENEW_SESSION,
  callback,
})
export const logout = (payload = {}) => ({ type: LOGOUT, payload })
export const updateUser = payload => ({ type: UPDATE_USER, payload })
export const updateUserProperty = payload => ({
  type: UPDATE_USER_PROPERTY,
  payload,
})
export const updateBranding = payload => ({ type: UPDATE_BRANDING, payload })
export const liftLockout = () => ({ type: LIFT_LOCKOUT })
export const changeAccount = (payload, callback) => ({
  type: CHANGE_USER_ACCOUNT,
  callback,
  payload,
})

const addLoginError = payload => ({
  type: ADD_LOGIN_ERROR,
  payload,
})

// payload = { push: Function }
export const requestLeaseData = payload => ({
  type: REQUEST_LEASE_DATA,
  payload,
})

export const requestPasswordReset = createFormAction(REQUEST_PASSWORD_RESET)
export const verifyResetCode = createFormAction(VERIFY_RESET_CODE)
export const updatePassword = createFormAction(UPDATE_PASSWORD)
export const authorizePartial = push => ({ type: AUTHORIZE_PARTIAL, push })
export const createPassword = createFormAction(CREATE_PASSWORD)
export const verifyToken = createFormAction(VERIFY_TOKEN)
export const trackLoginActivity = (payload = {}) => ({
  type: TRACK_LOGIN,
  payload,
})

const updateLocales = (userSettings, properties) => {
  if (userSettings.propertyId) {
    const supportedLocales =
      properties[userSettings.propertyId] &&
      properties[userSettings.propertyId].locale_codes
    if (supportedLocales && supportedLocales.length > 0) {
      window.rpSettings.supportedLocales = supportedLocales
    }
    setSessionCookies(
      I18N_MOCK,
      getSessionCookies(I18N_MOCK) ||
        properties[userSettings.propertyId]?.preferred_locale_code ||
        'en_US',
    )
    local.set(LANGUAGE_SET_FROM_NORMAL_LOGIN, true)
  }
}

// sagas
function* getNextSettings() {
  // figure out if we already have a preferred property & lease
  // (from rehydrated state)
  const { properties, userSettings } = yield select()
  let nextSettings = {}
  let selectedProperty = {}
  // if we already have settings for the user
  // let's use them to get to the right place
  if (Object.keys(userSettings).length) {
    nextSettings = ['leaseId', 'propertyId'].reduce((obj, key) => {
      if (userSettings[key]) {
        return { ...obj, [key]: userSettings[key] }
      }
      return obj
    }, {})
    // set a reference to the selected property
    if (nextSettings.propertyId && !nextSettings.leaseId) {
      selectedProperty = properties[nextSettings.propertyId]
    }
  }
  // if there's no saved propertyId and exactly 1 property returned, save it
  if (!nextSettings.propertyId && Object.keys(properties).length === 1) {
    selectedProperty = Object.values(properties)[0]
    nextSettings.propertyId = selectedProperty.property_id
  }
  // check if we can also update the user's leaseId settings
  // (ie there's exactly 1 lease for the selected property)
  if (
    nextSettings.propertyId &&
    !nextSettings.leaseId &&
    selectedProperty.leases &&
    selectedProperty.leases.length === 1
  ) {
    nextSettings.leaseId = selectedProperty.leases[0]
  }

  yield all([
    put(updateUserSettings(nextSettings)),
    put(updateUser(nextSettings)),
  ])

  // if we have a propertyId at this point, set the i18n timezone
  if (nextSettings.propertyId) {
    const property = properties[nextSettings.propertyId]
    yield property?.timezone && call(i18nUtils.setTimezone, property.timezone)
  }
}

function* getContractNextSettings() {
  // figure out if we already have a preferred property & contract
  // (from rehydrated state)
  const { properties, userSettings } = yield select()
  let nextSettings = {}
  let selectedProperty = {}
  // if we already have settings for the user
  // let's use them to get to the right place
  if (Object.keys(userSettings).length) {
    nextSettings = ['contractId', 'propertyId'].reduce((obj, key) => {
      if (userSettings[key]) {
        return { ...obj, [key]: userSettings[key] }
      }
      return obj
    }, {})
    // set a reference to the selected property
    if (nextSettings.propertyId && !nextSettings.contractId) {
      selectedProperty = properties[nextSettings.propertyId]
    }
  }
  // if there's no saved propertyId and only 1 property returned, save it
  if (!nextSettings.propertyId && Object.keys(properties).length >= 1) {
    selectedProperty = Object.values(properties)[0]
    nextSettings.propertyId = selectedProperty.property_id
  }
  // check if we can also update the user's contractId settings
  // (ie there's only 1 contract for the selected property)
  if (
    nextSettings.propertyId &&
    !nextSettings.contractId &&
    selectedProperty.contracts.length >= 1
  ) {
    nextSettings.contractId = selectedProperty.contracts[0]
  }

  yield all([
    put(updateUserSettings(nextSettings)),
    put(updateUser(nextSettings)),
  ])

  // if we have a propertyId at this point, set the i18n timezone
  if (nextSettings.propertyId) {
    const property = properties[nextSettings.propertyId]
    yield call(i18nUtils.setTimezone, property.timezone)
  }
}

function* authRedirect(push) {
  let path = ''
  if (window.rpSettings.projectName == 'rh') {
    const { contractId } = yield select(({ userSettings }) => userSettings)
    if (contractId) {
      yield put(requestProductPermissions())
      yield put(trackLoginActivity())
      path = PRIVATE_ROOT
    } else {
      path = AUTH.SELECT_CONTRACT
    }
  } else {
    const {
      userSettings: { leaseId, propertyId, isBulkPayment },
      user: { token, cid },
      properties: allProperties,
    } = yield select(({ userSettings, user, properties }) => ({ userSettings, user, properties }))
    const propertyCount = allProperties ? Object.keys(allProperties).length : 0
    const selectedPropertyLeaseCount = (propertyId && allProperties && allProperties[propertyId] && allProperties[propertyId].leases && allProperties[propertyId].leases.length) || 0
    path = AUTH.SELECT_PROPERTY
    // if we already have a property
    if (propertyId) {
      if (propertyCount > 1) {
        path = AUTH.SELECT_PROPERTY
      } else if (selectedPropertyLeaseCount > 1) {
        path = AUTH.CHOOSE_OPTION
      } else if (local.get(ENABLE_BULK_PAYMENT)) {
        path = AUTH.CHOOSE_OPTION
      } else if (leaseId) {
        yield call(requestProductPermissions)
        yield put(trackLoginActivity())
        const { productPermissions } = yield select()
        path = getLandingPage({
          landingPage: productPermissions?.secondary_menu?.[0]?.id,
        })
      } else if (isBulkPayment) {
        path = getLandingPage({
          landingPage: 'Bulk_Payments',
        })
      } else {
        // select the lease from available options
        localStorage.removeItem('beforeLoginUrl')
        path = AUTH.CHOOSE_OPTION
      }
    }
    if (cid === 15077) {
      yield call(
        logNrError,
        { path, isBulkPayment, leaseId, propertyId, token },
        'recordError',
      )
    }
  }

  if (localStorage.beforeLoginUrl) {
    // Validate the URL by checking if it contains the '/app' route using indexOf.
    // If it's valid, extract the relevant part of the URL and redirect.
    // If not, leave the URL unchanged to allow redirection to PageNotFound or the default route.
    const slicedIndex = localStorage.beforeLoginUrl.indexOf('/app')
    if (slicedIndex != -1) {
      path = localStorage.beforeLoginUrl.slice(slicedIndex)
    }
  }

  if (path) {
    yield call(push, path)

    // Not removing beforeLoginUrl for view document.
    // Ex: http://localhost:3000/app/apartment/documents/25447801/view

    if (
      !(
        localStorage.beforeLoginUrl &&
        /documents\/\d+\/view/.test(localStorage.beforeLoginUrl)
      )
    ) {
      localStorage.removeItem('beforeLoginUrl')
    }
  }
}
export function* handlePartialAuth({ push }) {
  if (window.rpSettings.projectName == 'rh') {
    yield getContractNextSettings()
    yield authRedirect(push)
  } else {
    yield getNextSettings()
  }
  console.log('handlePartialAuth')
  yield authRedirect(push)
}

export function* handleRenewSession({ callback }) {
  const { token } = yield call(Api.renewSession)
  if (token) typeof callback === 'function' && callback()
  yield all([
    put({
      type: RENEW_SESSION_SUCCESSFULL,
      payload: token,
    }),
    call(setSessionCookies, JWT_STORAGE_KEY, token),
  ])
}

export function* watchRenewToken() {
  yield takeLatest(
    REQUEST_RENEW_SESSION,
    createRequestSaga(handleRenewSession, {
      key: 'Renew Token',
      message: __('Extending Session'),
    }),
  )
}

export function* processLeaseData({
  key,
  data,
  push,
  settingValues = {},
  is_test_client,
}) {
  let responseData = {}
  if (window.rpSettings.projectName === 'tp') {
    responseData = Api.normalizeTenantProperties(data)
  } else {
    responseData = Api.normalizeProperties(data)
  }

  const { properties, ...apiResponseData } = responseData
  let leases, rest
  if (window.rpSettings.projectName === 'tp') {
    let { leases: onlyLeases, tenants } = apiResponseData
    leases = {}
    if (onlyLeases) {
      leases = { ...onlyLeases }
    }

    if (tenants) {
      leases = { ...leases, ...tenants }
    }

    properties &&
      Object.keys(properties)?.map(
        key =>
          (properties[key] = {
            ...properties[key],
            leases: properties[key]['propertyLeases'],
          }),
      )
  } else {
    const { leases: onlyLeases, ...restData } = apiResponseData
    leases = onlyLeases
    rest = restData
  }

  if (local.get(LANGUAGE_PREFERENCE)) {
    updateLocaleCookie({
      language_preference: local.get(LANGUAGE_PREFERENCE),
    })
  }

  setDefaultLocale(
    data[0].preferred_locale_code || data[0].property_locale_code,
  )

  yield put(receivePropertyAssociations({ leases, properties }))
  yield put(
    receiveAccountSettings({
      language_preference: data[0].preferred_locale_code,
    }),
  )
  yield getNextSettings()
  const { user, userSettings } = yield select()
  let token
  let propertyToken
  let decodedToken
  // if we have a leaseId in settings, get our token from it
  if (
    userSettings.leaseId &&
    leases[userSettings.leaseId] &&
    'undefined' != typeof leases[userSettings.leaseId]
  ) {
    if (leases?.[userSettings?.leaseId]) {
      token = leases[userSettings.leaseId].token
      decodedToken = decode(token).data
      decodedToken.readOnly = user.readOnly
    }
  } else {
    const propertyCount = properties ? Object.keys(properties).length : 0
    const hasMultipleOptions = propertyCount > 1 ||
      (userSettings.propertyId && properties[userSettings.propertyId]?.leases?.length > 1)
    const isRpWithLeases =
      window.rpSettings.projectName === 'rp' &&
      Object.values(leases).length > 0 &&
      typeof userSettings.leaseId == 'undefined' &&
      userSettings.propertyId &&
      properties[userSettings.propertyId] &&
      'undefined' != typeof properties[userSettings.propertyId] &&
      properties[userSettings.propertyId].leases.length > 0

    if (!isRpWithLeases && !hasMultipleOptions) {
      yield put(
        addError({
          key: 'login',
          message: __(
            'Your account has been found but access is not allowed at this time. Please contact your property for details.',
          ),
        }),
      )
    }
  }

  if (userSettings.propertyId) {
    propertyToken = properties?.[userSettings?.propertyId]?.token
  }

  token = userSettings.leaseId ? token : propertyToken

  if (getProjectName() === 'tp' && userSettings?.propertyId) {
    const entrataDomain = properties?.[userSettings.propertyId]?.entrata_domain
    const apiPassword =
      process.env.NODE_ENV === 'production'
        ? process.env.AMENITY_API_SECRET_PASSWORD_FOR_LIVE
        : process.env.AMENITY_API_SECRET_PASSWORD

    const authCredentials = `${process.env.AMENITY_API_SECRET_USERNAME}:${apiPassword}`
    
    sessionStorage.setItem(ENTRATA_DOMAIN, entrataDomain)
    sessionStorage.setItem(USER_AUTH, btoa(authCredentials))
  }

  updateLocales(userSettings, properties)

  yield call(Api.local.set, LOGIN_TRACKED, 0)
  yield put({
    type: LOGIN_SUCCESSFUL,
    payload: {
      ...rest,
      user: {
        key,
        token: token || true,
        username: key,
        ...(decodedToken || userSettings),
        is_test_client,
      },
    },
  })

  if (settingValues && Object.keys(settingValues).length) {
    yield put({
      type: SAVE_NOTIFICATION_SETTINGS_NEW,
      payload: { ...settingValues },
    })
  }

  try {
    yield call(addSetupData, key, { leases, properties, is_test_client })
  } catch (e) {
    // non-critical: setup data cache failure should not block login
  }
  yield authRedirect(push)
  if (userSettings.leaseId || window.rpSettings.projectName === 'rp') {
    const branding = yield getBranding(userSettings, properties)
    if (window.rpSettings.projectName === 'rp') {
      yield branding !== null &&
        put(updateBranding({ branding, hardReload: true }))
    } else {
      yield branding !== null && put(updateBranding({ branding }))
    }
  }
}

export function* handleUserCookieToken({ payload, callback }) {
  try {
    const { leases, properties, cid, accessToken } = yield select(
      ({ leases, properties, cid, user }) => ({
        leases,
        properties,
        cid,
        accessToken: user?.token,
      }),
    )
    let userToken
    if (payload.type === 'property') {
      userToken = properties[payload?.id]?.token
    } else {
      userToken = leases[payload?.id]?.token || accessToken
    }
    let iv = generateRandomBytes(8)
    const { token, token_iv } = yield userToken &&
      call(Api.generateToken, {
        token: getEncryptedAES256CBCToken(userToken, iv),
        token_iv: iv,
        cid,
      })
    const decryptedToken = getDecryptedAES256CBCToken(token, token_iv)
    if (payload.type !== 'property') { 
      yield put(updateUser({ isTokenLogin: true }))
    }
    if (typeof callback === 'function') {
      yield callback(decryptedToken)
    }
  } catch (error) {
    console.log('token error', error)
    local.set(FORCE_LOGOUT, 1)
    yield put(logout())
  }
}

export function* processContractData({ key, data, push }) {
  const {
    contracts: onlyContracts,
    groups,
    properties,
    ...rest
  } = Api.normalizeContractProperties(data)

  let contracts = []
  if (onlyContracts) {
    contracts = onlyContracts
  } else if (groups) {
    contracts = [...contracts, ...groups]
  }

  yield put(receiveContractPropertyAssociations({ contracts, properties }))
  yield getContractNextSettings()
  const { userSettings } = yield select()
  let token
  let decodedToken

  // if we have a contractId in settings, get our token from it
  if (userSettings.contractId) {
    token = contracts[userSettings.contractId].token
    decodedToken = decode(token).data
    const branding = yield getBranding(userSettings, properties)
    yield branding !== null && put(updateBranding({ branding }))
  }

  updateLocales(userSettings, properties)
  yield call(Api.local.set, LOGIN_TRACKED, 0)
  yield put({
    type: LOGIN_SUCCESSFUL,
    payload: {
      ...rest,
      user: {
        key,
        token: token || true,
        username: key,
        ...(decodedToken || userSettings),
      },
    },
  })
  // sync the setup data to the user key
  // so we don't have to fetch on page reload
  yield call(addSetupData, key, { contracts, properties })
  // redirect as needed
  yield authRedirect(push)
}

function* authorize({ username, password, push, settingValues = {} }) {
  let AuthParams = {
    username,
    password,
  }

  if (window.rpSettings.projectName !== 'rp') {
    let { sso_token } = parseQueryString(window.location.href)

    if (sso_token && sso_token !== '') {
      AuthParams = { ...AuthParams, sso_token }
    }

    yield call(Api.local.set, LOGIN_FROM_ENTRATA, false)
  }

  if (window.rpSettings.projectName == 'rh') {
    const { group_contracts } = yield call(Api.login, AuthParams)

    yield handleUserConfirmation(username, password)
    yield call(processContractData, {
      key: username,
      data: group_contracts,
      push,
    })
  } else {
    const { user_properties, is_test_client } = yield call(
      Api.login,
      AuthParams,
    )

    const { userSettings } = yield select()
    //if we don't have settings, check if we have them locally
    //(since user key comes from token and it's not there on logout + refresh)
    if (!userSettings[username]) {
      const localSettings = yield call(getSessionCookies, SETTINGS_STORAGE_KEY)
      if (localSettings && localSettings[username]) {
        yield put(updateUserSettings(localSettings[username]))
      }
      yield window.rpSettings.projectName === 'tp' &&
        handleUserConfirmation(username, password)
    }
    if (user_properties && window.rpSettings.projectName === 'rp') {
      event({
        action: 'Click to Link',
        category: 'Engagement',
        label: 'Resident Log In',
        value: 1,
      })
    }
    if (is_pp_login_success) {
      event({
        action: 'Click to Link',
        category: 'Engagement',
        label: 'Widget Resident Login Button',
        value: 1,
      })
    }
    yield call(processLeaseData, {
      key: username,
      data: user_properties,
      push,
      settingValues,
      is_test_client,
    })
  }
}

function* fetchLeaseData({ payload }) {
  const { user_properties } = yield call(Api.getLeaseData, {
    is_embedded,
    is_login_from_entrata,
  })
  const key = yield select(({ user }) => user.key)
  yield call(processLeaseData, {
    key,
    data: user_properties,
    ...payload,
  })
}

function* handleLogout(logoutRedirectURLPayload) {
  yield put(
    setLoading({
      key: 'global',
      message: __('Logging you out'),
    }),
  )
  // remove the jwt and all setup data from local storage
  const { userKey, token, cid } = yield select(({ user }) => ({
    userKey: user?.key,
    token: user?.token,
    cid: user?.cid,
  }))
  yield all([
    put({ type: LOGOUT_COMPLETE }),
    put(clearUserSettings()),
    call(removeSessionCookies, JWT_STORAGE_KEY),
    call(removeSessionCookies, SETTINGS_STORAGE_KEY),
    call(Api.local.remove, LANGUAGE_PREFERENCE),
    call(Api.local.remove, ENABLE_BULK_PAYMENT),
    call(Api.local.remove, LANGUAGE_SET_FROM_NORMAL_LOGIN),
    call(Api.local.remove, PAYMENT_ACCOUNT_ID),
    call(Api.local.remove, IS_RELINK_ACCOUNT),
    call(Api.local.remove, PLAID_REDIRECTED),
    call(Api.local.remove, PLAID_CONFIRM_MICRODEPOSIT),
    call(Api.local.remove, AUTO_PAYMENT_TYPE),
    call(Api.local.remove, RESTORE_FORM),
    call(Api.local.remove, IS_DONATION_SELECTED),
    call(Api.local.remove, PAYMENT_AMOUNT),
    call(Api.local.remove, AMOUNT_ERROR),
    call(Api.local.remove, RP_LEASE_ID),
    call(Api.local.remove, RP_PROPERTY_ID),
    call(clearSetupData, userKey),
    call(Api.local.remove, RP_SESSION_COOKIE_DELETED),
    call(Api.local.remove, PP_LOGIN_SUCCESS),
    call(Api.local.remove, IS_PUSH_NOTIFICATION_CALLED),
    ...(isTP ? [
      sessionStorage.removeItem(LOGIN_FROM_ENTRATA),
      sessionStorage.removeItem(CLIENT_ID_KEY),
      sessionStorage.removeItem(CLUSTER_KEY),
      sessionStorage.removeItem(IS_COMPANY_USER_FULL_ACCESS),
      sessionStorage.removeItem(ENTRATA_DOMAIN),
      sessionStorage.removeItem(USER_AUTH),
      sessionStorage.removeItem(SETUP_DATA_KEY)
    ] : [
      call(Api.local.remove, LOGIN_FROM_ENTRATA),
      call(Api.local.remove, CLIENT_ID_KEY),
      call(Api.local.remove, CLUSTER_KEY),
      call(Api.local.remove, SETUP_DATA_KEY)
    ]),
    call(Api.local.remove, 'beforeLoginUrl'), // Remove value of beforeLoginUrl
  ])
  if (typeof token === 'string') {
    const { jti, exp } = decode(token) || {}
    yield isRP && call(Api.userLogout, { jti: jti, cid, exp })
  }
  // unset loading with a slight delay if we just logged out
  yield delay(1000)

  yield put(unsetLoading({ key: 'global' }))
  // Remove key from local storage so on next load we can ask user update preferred language
  if (typeof Storage !== 'undefined') {
    localStorage.removeItem('locale_update_cancelled')
    localStorage.removeItem('language_updated_from_settings')
  }

  const thirdPartyLogoutRedirectURL =
    logoutRedirectURLPayload?.payload?.thirdPartyLogoutRedirectURL || ''
  if ('' != thirdPartyLogoutRedirectURL) {
    window.location.href = thirdPartyLogoutRedirectURL
  }
  //Removing the Oauth Token and its Expiry on logout
  localStorage.removeItem('newLinkToken')
  localStorage.removeItem('linkTokenExpiry')
  localStorage.removeItem('nonce')
  localStorage.removeItem('formFields')
  localStorage.removeItem('refreshPaymentAccountApiTime')

  localStorage.removeItem('restoreForm')
  localStorage.removeItem('addingPlaidItem')
  localStorage.removeItem('plaid_redirected')
  localStorage.removeItem('plaid_confirm_redirect')

  if (isTP || isRH) {
    window.location.replace(PUBLIC_ROOT)
  }
}

function* authFlow() {
  // we need to know if the state has been rehydrated with a token
  // (meaning the user is already logged in)
  // It's not a complete login unless we have a valid token
  // a selected leaseId and propertyId
  // and matches for those ids in leases/properties
  while (true) {
    const state = yield select()
    let authenticated = checkAuthenticated(state)
    if (window.rpSettings.projectName !== 'rp') {
      let { sso_token } = parseQueryString(window.location.href)

      if (sso_token) {
        if (state.user.token) {
          authenticated = false
          state.user.token = null
          yield call(handleLogout)
        }
      }
    }

    // if we have a token but not authenticated, sync token to localStorage
    // (for third-party logins, so we can fetch leases/properties)
    if (state.user.token) {
      yield call(setSessionCookies, JWT_STORAGE_KEY, state.user.token)
    }

    // if we already have a token, skip listening for login requests
    if (!authenticated) {
      const { payload } = !state.user.token ? yield take(LOGIN_REQUEST) : {}
      yield fork(
        createRequestSaga(authorize, {
          key: 'login',
          message: __('Logging you in'),
          duration: 100,
          onError: handleLoginError,
        }),
        payload,
      )
    }

    // start listening for logout and login errors
    const { type } = yield take([LOGOUT, ADD_LOGIN_ERROR, LOCK_USER_OUT])
    if (type === LOGOUT) {
      authenticated = false
      if (type === LOGOUT) yield call(handleLogout)
    }
  }
}

export function* handleLoginError(
  { code, attempt_count, lockout_until, message },
  { key },
) {
  switch (code) {
    case 3127:
    case 3128:
      yield put(
        addLoginError({
          key,
          message: attempt_count
            ? __(
                'Login details are incorrect. You have {%d, 0} more login attempt(s) left.',
                [10 - +attempt_count],
              )
            : message,
        }),
      )
      break
    case 3124:
      yield put(
        addLoginError({
          key,
          message: __(
            'You are less than {%d, 0} years of age. Please have your parents contact the main office for assistance.',
            [18],
          ),
        }),
      )
      break
    default: {
      if (+lockout_until) {
        yield put({
          type: LOCK_USER_OUT,
          payload: +lockout_until * 1000,
        })
      } else {
        const hasLanguageSet =
          localStorage.getItem(LANGUAGE_SET_FROM_NORMAL_LOGIN) || isNotRP
        const errorMessage = ERROR_MSGS[code]
        yield put(
          addLoginError({
            key,
            message: hasLanguageSet
              ? errorMessage || __('Something went wrong.')
              : message || __('Something went wrong.'),
          }),
        )

        break
      }
    }
  }
}

function* handlePropertyChange({ payload }) {
  if (!payload.propertyId) return false

  const property = yield select(
    ({ properties }) => properties[payload.propertyId],
  )

  if (!property) {
    yield payload.history &&
      payload.history.push({
        pathname: AUTH.CHOOSE_OPTION,
      })
    return true
  }

  yield property.timezone && call(i18nUtils.setTimezone, property.timezone)
  yield property.cluster_id &&
    call(Api.local.set, CLUSTER_KEY, property.cluster_id)

  yield payload.history &&
    payload.history.push({
      pathname: PRIVATE_ROOT,
    })

  const { userSettings, properties } = yield select()
  if (userSettings.propertyId) {
    const branding = yield getBranding(userSettings, properties)
    yield branding !== null && put(updateBranding({ branding }))
  }

  return true
}

function* watchUpdateUser() {
  yield takeEvery(UPDATE_USER, handlePropertyChange)
}

function* handleUserPropertyChange({ payload: { propertyId, callback } }) {
  if (!propertyId) return false
  const { clientProperties } = yield select()
  let property = clientProperties.filter(
    clientProperty => clientProperty.id == propertyId,
  )?.[0]

  if (!property)
    property = yield select(({ properties }) => properties[propertyId])

  local.set(FORCE_LOGOUT, 1)
  yield property.timezone && call(i18nUtils.setTimezone, property.timezone)
  yield property.cluster_id &&
    call(Api.local.set, CLUSTER_KEY, property.cluster_id)

  yield typeof callback === 'function' && callback()
}

function* handleOtpError(err, { action: { payload } }) {
  if (err.code === 3127) {
    yield typeof payload.callback === 'function' && payload.callback()
    return
  }
  yield put(addError({ key: 'otpLogin', message: err.message }))
}

function* handleOtpSubmitError(err) {
  if (err.code === 3127) {
    yield put(
      addError({
        key: 'otpLogin',
        message: __('Invalid code. You have 2 attempts remaining.'),
      }),
    )
  } else {
    yield put(addError({ key: 'otpLogin', message: err.message }))
  }
}

function* watchUpdateUserProperty() {
  yield takeEvery(UPDATE_USER_PROPERTY, handleUserPropertyChange)
}

function* watchRequestLeaseData() {
  yield takeLatest(
    REQUEST_LEASE_DATA,
    createRequestSaga(fetchLeaseData, {
      key: 'login',
      message: __('Logging you in'),
      duration: 100,
    }),
  )
}

function* watchOtpRequest() {
  yield takeLatest(
    EMAIL_OTP_REQUEST,
    createRequestSaga(fetchOtpData, {
      key: 'otpLogin',
      message: __('Please wait...'),
      duration: 100,
      onError: handleOtpError,
    }),
  )
}

function* watchOtpSubmitRequest() {
  yield takeLatest(
    EMAIL_OTP_SUBMIT_REQUEST,
    createRequestSaga(postOtpSubmitData, {
      key: 'otpLogin',
      message: __('Verifying Credentials'),
      duration: 100,
      onError: handleOtpSubmitError,
    }),
  )
}

function* fetchOtpData({ payload }) {
  yield call(Api.generateOtp, payload.payload)
  typeof payload?.callback === 'function' && payload?.callback()
}

function* postOtpSubmitData({ payload }) {
  const { username, otp_code, push, settingValues = {} } = payload.payload
  const { user_properties, is_test_client } = yield call(Api.otpLogin, {
    username,
    otp_code,
  })
  const { userSettings } = yield select()
  //if we don't have settings, check if we have them locally
  //(since user key comes from token and it's not there on logout + refresh)
  if (!userSettings[username]) {
    const localSettings = yield call(getSessionCookies, SETTINGS_STORAGE_KEY)
    if (localSettings && localSettings[username]) {
      yield put(updateUserSettings(localSettings[username]))
    }
  }

  event({
    action: 'Click to Link',
    category: 'Engagement',
    label: 'Resident Log In',
    value: 1,
  })

  setSessionCookies(OTP_LOGIN, { enable_update_password_popup: true }, true)

  yield call(processLeaseData, {
    key: username,
    data: user_properties,
    push,
    settingValues,
    is_test_client,
  })
}

function* handleChangeAccount({ payload }) {
  const { productPermissions } = yield select()
  const changeUnitTo =
    productPermissions?.change_unit_to ||
    productPermissions?.resident_portal?.change_unit_to

  yield put(
    setLoading({
      key: 'change-account',
      message: __('Changing your {%s,0}', [
        changeUnitTo ? changeUnitTo.toLowerCase() : 'unit',
      ]),
    }),
  )

  let token
  if (
    true == payload?.isBulkPayment &&
    (local.get(ENABLE_BULK_PAYMENT) ||
      (typeof payload?.leaseId == 'undefined' &&
        typeof payload?.token == 'undefined'))
  ) {
    token = yield select(({ user }) => user?.token)
  } else {
    token = yield select(
      ({ leases }) => payload?.token || leases[payload.leaseId].token,
    )
  }

  yield all([
    put(updateUser({ ...payload, token })),
    put(
      payload?.token && isRP
        ? requestPropertyProductPermissions()
        : requestProductPermissions(),
    ),
    put(trackLoginActivity()),
    put(requestChecklists()),
  ])

  yield delay(2000)
  yield put(unsetLoading({ key: 'change-account' }))

  yield put(
    setLoadingSuccess({
      key: 'change-account',
      message: __('{$s,0} successfully changed', [
        changeUnitTo ? changeUnitTo.toLowerCase() : 'Unit',
      ]),
    }),
  )

  const { userSettings, properties } = yield select()

  if (payload.isBulkPayment) {
    yield put(updateUserSettings({ ...userSettings, isBulkPayment: true }))
    yield put(resetBalanceDue())
    typeof payload.callback == 'function' && payload.callback()
  }

  if (
    false ==
    ((local.get(ENABLE_BULK_PAYMENT) && true == payload?.isBulkPayment) ||
      true == payload?.isBulkPayment)
  ) {
    let branding = yield getBranding(userSettings, properties)

    yield branding !== null &&
      put(updateBranding({ branding, hardReload: true }))
  }

  isRP && typeof payload.callback == 'function' && payload.callback()
}

function* watchChangeAccount() {
  yield takeEvery(
    CHANGE_USER_ACCOUNT,
    createRequestSaga(handleChangeAccount, { key: 'change-account' }),
  )
}

function* postResetRequest({ type, payload, callback }) {
  const action =
    type === REQUEST_PASSWORD_RESET
      ? Api.requestPasswordReset
      : Api.validateResetCode
  let response = yield call(action, payload)
  // Adding a temp code As on HA Trunk we are getting the string instead of object
  if ('tp' === window.rpSettings.projectName) {
    if (typeof reseponse === 'string') {
      response = JSON.parse(response)
      if (
        isObject(response) &&
        response.code &&
        typeof response.message == 'string'
      ) {
        handleVerifyCodeError(response)
        return false
      }
    } else {
      if (
        parseInt(response.code) == 1024 &&
        isObject(response.extra) &&
        typeof response.extra.payload === 'string'
      ) {
        var resetPayload = JSON.parse(response.extra.payload)
        if (isObject(resetPayload)) {
          response = yield call(Api.sendResetPassword, resetPayload)
        } else {
          return false
        }
      }
    }
  }

  yield put(updateUser({ reset: payload }))
  // if we get a token back, sync it so we can create a new password
  if (isObject(response) && typeof response.token === 'string') {
    yield put({
      type: LOGIN_SUCCESSFUL,
      payload: {
        user: {
          token: response.token || true,
        },
      },
    })
    yield call(setSessionCookies, JWT_STORAGE_KEY, response.token)
    yield call(Api.local.set, RESET_PASSWORD_KEY, true)
  }

  typeof callback === 'function' && callback()
}

function* postNewPassword({ payload, callback }) {
  yield call(Api.updatePassword, payload)
  yield put({ type: PASSWORD_RESET })
  // clear temp token so the user can login without any problems
  yield call(removeSessionCookies, JWT_STORAGE_KEY)
  yield call(Api.local.remove, RESET_PASSWORD_KEY)
  typeof callback === 'function' && callback()
}

function* watchRequestReset() {
  yield takeLatest(
    REQUEST_PASSWORD_RESET,
    createRequestSaga(postResetRequest, {
      key: 'resetPassword',
      message: __('Verifying email address'),
    }),
  )
}

function* handleVerifyCodeError({ code }, { key }) {
  switch (code) {
    case 1002:
      yield put(addError({ key, message: __('Invalid reset code.') }))
      break
    default:
      yield put(
        addError({
          key,
          message: ERROR_MSGS[code] || __('Something went wrong.'),
        }),
      )
      break
  }
}

function* watchVerifyCode() {
  yield takeLatest(
    VERIFY_RESET_CODE,
    createRequestSaga(postResetRequest, {
      key: 'resetPassword',
      message: __('Verifying reset code'),
      onError: handleVerifyCodeError,
    }),
  )
}

function* watchResetPassword() {
  yield takeLatest(
    UPDATE_PASSWORD,
    createRequestSaga(postNewPassword, {
      key: 'resetPassword',
      message: __('Updating your password'),
    }),
  )
}

function* watchPartialAuth() {
  yield takeLatest(AUTHORIZE_PARTIAL, handlePartialAuth)
}

function* watchLogOut() {
  yield takeLatest(LOGOUT, handleLogout)
}

function* getBranding(userSettings, properties) {
  let branding = yield userSettings && userSettings.propertyId
    ? properties[userSettings.propertyId] &&
      properties[userSettings.propertyId].branding
    : null

  return branding
}

function* handleUserConfirmation(username, password) {
  const ssoToken = yield call(Api.local.get, SSO_TOKEN_KEY)

  let cid
  if ('tp' === window.rpSettings.projectName) {
    cid = yield call(Api.local.get, CLIENT_ID_KEY)
  } else {
    cid = window.rpSettings.cid
  }

  if (!(username != '' && ssoToken && ssoToken != '' && cid && cid > 0))
    return false

  yield put(
    setLoading({
      key: 'global',
      message: __('Confirming Contact'),
    }),
  )

  const isContactConfirmed = yield call(Api.confirmContact, {
    cid,
    token: ssoToken,
    username,
    password,
  })

  yield delay(500)
  // set success or clear loader (depending on type)
  if (!isContactConfirmed) {
    yield put(unsetLoading({ key: 'global' }))
    return false
  }

  yield put(
    setLoadingSuccess({
      key: 'global',
      message: __('Contact Confirmed Successfully'),
    }),
  )
}

function* handleBrandingChange({ payload: { branding, hardReload } }) {
  /*
  // Disabling the code of Reloading for branding change
  if (
    hardReload &&
    ['tp', 'rp'].indexOf(window.rpSettings.projectName) !== -1
  ) {
    yield delay(200)
    yield window.location.reload()
  }
  */
}

function* watchUpdateBranding() {
  yield takeEvery(UPDATE_BRANDING, handleBrandingChange)
}

function* postCreatePassword({ payload, callback }) {
  const postData = {
    ...payload,
    phone_number: `+${payload.phone_locale || i18nUtils.getCountryCode()} ${
      payload.phone
    }`,
  }
  const response = yield call(Api.createPassword, postData)

  typeof callback === 'function' && callback(response)
}

function* postVerifyToken({ payload, callback }) {
  const response = yield call(Api.verifyToken, {
    token: payload.token,
    reset_password: payload.reset_password,
  })
  typeof callback === 'function' && callback(response)
}

function* postTrackLoginAcitivty({ payload }) {
  const loginTracked = yield call(Api.local.get, LOGIN_TRACKED, 0)
  // Check both localStorage and sessionStorage for login_from_entrata
  
  const loginFromEntrataLocal = yield call(Api.local.get, LOGIN_FROM_ENTRATA)
  const loginFromEntrataSession = sessionStorage.getItem(LOGIN_FROM_ENTRATA)
  const loginFromEntrata = loginFromEntrataLocal || loginFromEntrataSession
  
  yield !loginFromEntrata &&
    parseInt(loginTracked) == 0 &&
    ['tp', 'rh'].includes(window.rpSettings.projectName) &&
    call(Api.logLoginActivity, { token: payload.token })
}

function* watchCreatePassword() {
  yield takeLatest(
    CREATE_PASSWORD,
    createRequestSaga(postCreatePassword, {
      key: 'createPassword',
      message: __('Creating Account'),
    }),
  )
}

function* watchUserToken() {
  yield takeLatest(
    SET_USER_TOKEN,
    createRequestSaga(handleUserCookieToken, {
      key: 'login',
      message: __('Fetching Properties'),
    }),
  )
}

function* watchTrackLogin() {
  yield ['tp', 'rh'].includes(window.rpSettings.projectName) &&
    takeLatest(
      TRACK_LOGIN,
      createRequestSaga(postTrackLoginAcitivty, {
        key: 'global',
        message: __('Logging In'),
      }),
    )
}

function* watchVerifyToken() {
  yield takeLatest(
    VERIFY_TOKEN,
    createRequestSaga(postVerifyToken, {
      key: 'createPassword',
      message: __('Verifying Token'),
      onError: function* handleVerifyCodeError(
        { code, message },
        {
          key,
          action: {
            payload: { history },
          },
        },
      ) {
        let { token } = parseQueryString(window.location.href)
        yield call(Api.local.set, SSO_TOKEN_KEY, token)

        switch (code) {
          case 3125:
            history.push(AUTH.USED_TOKEN)
            yield put(addError({ key, message }))

            break
          case 2007:
            history.push(AUTH.INVALID_TOKEN)
            yield put(addError({ key, message }))

            break
          default:
            yield put(
              addError({
                key,
                message: ERROR_MSGS[code] || __('Something went wrong.'),
              }),
            )
            break
        }
      },
    }),
  )
}

export const sagas = [
  authFlow,
  watchRenewToken,
  watchLogOut,
  watchRequestLeaseData,
  watchUpdateUser,
  watchUpdateUserProperty,
  watchChangeAccount,
  watchRequestReset,
  watchVerifyCode,
  watchResetPassword,
  watchPartialAuth,
  watchUpdateBranding,
  watchCreatePassword,
  watchVerifyToken,
  watchTrackLogin,
  watchOtpRequest,
  watchOtpSubmitRequest,
  watchUserToken,
]
